import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Typography } from '@material-ui/core';

import { useStyles } from './useStyles';

export const DetailsItem = ({ className, title, text, examples }) => {
  const styles = useStyles();

  return (
    <div className={cx(styles.root, className)}>
      <Typography className={styles.title}>{title}:</Typography>

      {text && <Typography className={styles.text}>{text}</Typography>}

      {examples?.length > 0 &&
        examples.map((example, index) => (
          <Typography
            className={styles.text}
            key={`${example}_${index}`}
          >
            {example}
          </Typography>
        ))}
    </div>
  );
};

DetailsItem.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string.isRequired,
  text: PropTypes.string,
  examples: PropTypes.arrayOf(PropTypes.string),
};

DetailsItem.defaultProps = {
  className: '',
  text: '',
  examples: [],
};
